/* eslint-disable no-useless-constructor */
import Model from '@/models/Model'

export default class LegalDocument extends Model {
    resource() {
        return 'legal-documents'
    }

    primaryKey() {
        return 'code'
    }
}